import { render, staticRenderFns } from "./BasiLayout.vue?vue&type=template&id=137aedd8"
import script from "./BasiLayout.vue?vue&type=script&lang=js"
export * from "./BasiLayout.vue?vue&type=script&lang=js"
import style0 from "./BasiLayout.vue?vue&type=style&index=0&id=137aedd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports